import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
  } from '@/components/ui/alert-dialog';
  import { useQueryClient } from '@tanstack/react-query';
  
  export type DeleteIndicatorScoreConfirmationProps = {
    isOpen: boolean;
    handleOpen: (boolean: boolean) => void;
    indicatorscoreId: string;
  };
  
  export const DeleteIndicatorScoreConfirmation = ({
    isOpen,
    handleOpen,
    indicatorscoreId,
  }: DeleteIndicatorScoreConfirmationProps) => {
    const queryClient = useQueryClient();
    const params = $router.get()?.params as Record<'organizationId', string>;
    const [deletingIndicatorScore, setDeletingIndicatorScore] = useState(false);
  
    return (
      <AlertDialog open={isOpen} onOpenChange={handleOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
            <AlertDialogDescription>
              This action cannot be undone. This will permanently delete this
              indicator score and remove all the data inside it from our servers.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={async e => {
                e.preventDefault();
                setDeletingIndicatorScore(true);
                await deleteIndicatorScore(params.organizationId ?? '', indicatorscoreId);
                setDeletingIndicatorScore(false);
                handleOpen(false);
              }}
              disabled={deletingIndicatorScore}
              className="bg-red-600 hover:bg-red-500 dark:text-white dark:hover:bg-red-700"
            >
              {deletingIndicatorScore ? 'Processing...' : 'Continue'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    );
};
    